import {ActivatedRoute, Router} from '@angular/router';
import {environment} from "../../../environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {BroadcasterService} from "../broadcaster.service";
import {GridDataResult} from "@progress/kendo-angular-grid";
const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
});

@Injectable({
    providedIn: 'root'
})
export class OrganizationsService {

    constructor(private broadcaster: BroadcasterService, private http: HttpClient, private router: Router, private route: ActivatedRoute) {}

    public getOrganizations(): Observable<any> {
        return new Observable<any>(observer => {
            this.http.post<any>(environment.apiUrl + 'de/getOrgs',
                {sid: localStorage.getItem('token')})
                .subscribe((res: any) => {
                    observer.next(res);
                }, err => {
                    observer.error(err);
                });
        });
    }
}
